import styled from 'styled-components';

type StreamingProviderNoticeProps = {
  className?: string;
};

export const StreamingProviderNotice = ({ className }: StreamingProviderNoticeProps) => (
  <ProviderFooter className={className}>
    <span>4G plans by Stream Group Technology Ltd · Registered in Scotland, SC804365</span>
    <span>Registered office: Unit 2 Ruthvenfield Avenue, Inveralmond Industrial Estate, Perth PH1 3WB</span>
  </ProviderFooter>
);

const ProviderFooter = styled.footer`
  width: 100%;
  max-width: 72rem;
  margin: 2rem auto 0;
  padding: 1rem 1.5rem 0;
  border-top: 1px solid #dce7eb;
  color: #5b7179;
  font-size: 0.75rem;
  line-height: 1.5;
  text-align: center;

  span {
    display: block;
  }
`;
